import {notifyUserOfCrash} from './slice'

const setLastDate = ()=>{
  const currentDate = new Date().toISOString().slice(0, 10); // get current date in YYYY-MM-DD format
  localStorage.setItem('lastDate', currentDate);
}

const check48HoursPassed = (callback)=>{
  const lastDate = localStorage.getItem('lastDate');
  //if not set yet then trigger the call back
  if (!lastDate) {
    setLastDate();
    callback();
    return 
  }
  const lastDateTime = new Date(`${lastDate}T00:00:00`).getTime(); // convert last date to timestamp
  const currentDateTime = new Date().getTime(); // get current timestamp
  const timeDiff = currentDateTime - lastDateTime;
  const hoursDiff = timeDiff / (1000 * 60 * 60); // convert time difference to hours
  if (hoursDiff >= 48) {
    setLastDate();
    callback();
  }
}

/**
 * Sends crash reports as state is updated and listeners are notified.
 */
const crashReporter = store => next => action => {
  try {
    return next(action)
  } catch (err) {
    check48HoursPassed(()=>{
      console.error('Caught an exception!', err)
      store.dispatch(
        notifyUserOfCrash({
          error:err.toString(),
          action,
          state:store.getState()
        })
      )//end dispatch
    })//end 48 hour check
  }//end catch
}//end crashReporter

export default crashReporter